/* FCB product page script: launch switch + countdown. */
(function () {
  var cfg = window.FCB || {};
  var launch = Date.parse(cfg.launch);
  var root = document.documentElement;
  var pad = function (n) { return String(n).padStart(2, '0'); };

  function paintCountdown(ms) {
    var d = Math.floor(ms / 864e5), h = Math.floor(ms / 36e5) % 24, m = Math.floor(ms / 6e4) % 60, s = Math.floor(ms / 1e3) % 60;
    document.querySelectorAll('[data-fcb-countdown]').forEach(function (el) {
      el.querySelector('[data-d]').textContent = pad(d);
      el.querySelector('[data-h]').textContent = pad(h);
      el.querySelector('[data-m]').textContent = pad(m);
      el.querySelector('[data-s]').textContent = pad(s);
    });
  }

  function tick() {
    if (isNaN(launch)) return true;
    var left = Math.max(0, launch - Date.now());
    paintCountdown(left);
    // Customers: flip to live at zero. Editor preview and the Launched toggle are left alone.
    if (left === 0 && cfg.preview === 'auto' && !cfg.launched) {
      root.setAttribute('data-fcb-state', 'live');
      return true;
    }
    return left === 0;
  }

  function start() {
    if (tick()) return;
    var timer = setInterval(function () { if (tick()) clearInterval(timer); }, 1000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  // ---------- hero slider ----------
  function initSlider(root) {
    if (root.dataset.fcbReady) return;
    root.dataset.fcbReady = '1';
    var track = root.querySelector('[data-fcb-track]');
    var dots = root.querySelector('[data-fcb-dots]');
    var prev = root.querySelector('[data-fcb-prev]');
    var next = root.querySelector('[data-fcb-next]');
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-fcb-slide]'));
    if (!slides.length) return;
    var current = 0;
    dots.innerHTML = '';
    slides.forEach(function (s, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Image ' + (i + 1) + ' of ' + slides.length);
      b.addEventListener('click', function () { go(i); });
      dots.appendChild(b);
    });
    if (slides.length < 2) { dots.hidden = true; prev.hidden = true; next.hidden = true; }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    function paint() {
      Array.prototype.forEach.call(dots.children, function (d, i) { d.setAttribute('aria-current', i === current ? 'true' : 'false'); });
      prev.disabled = current === 0;
      next.disabled = current === slides.length - 1;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { current = slides.indexOf(e.target); paint(); } });
    }, { root: track, threshold: 0.6 });
    slides.forEach(function (s) { io.observe(s); });
    prev.addEventListener('click', function () { go(current - 1); });
    next.addEventListener('click', function () { go(current + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
    });
    paint();
    root._fcbGo = function (el) { var i = slides.indexOf(el); if (i > -1) go(i); };
  }
  function initSliders() { document.querySelectorAll('[data-fcb-slider]').forEach(initSlider); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSliders);
  else initSliders();

  // Theme editor: rebuild after edits, and jump to a slide when it's selected in the sidebar.
  document.addEventListener('shopify:section:load', initSliders);
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target && e.target.closest && e.target.closest('[data-fcb-slide]');
    var root = slide && slide.closest('[data-fcb-slider]');
    if (root && root._fcbGo) root._fcbGo(slide);
  });

  // Re-paint when the theme editor re-renders a block.
  document.addEventListener('shopify:block:select', function () { tick(); });
  document.addEventListener('shopify:section:load', function () { tick(); });
})();
